import { IIndustryProjection } from '@/modules/dap/interfaces';

export class IndustryProjection implements IIndustryProjection {

  constructor (id: number, idProject: number, idSegmentGroup: number, year: number, value: number) {
    this.id = id;
    this.idProject = idProject;
    this.idSegmentGroup = idSegmentGroup;
    this.year = year;
    this.value = value;
  }

  id = 0;
  idProject = 0;
  idSegmentGroup = 0;
  year = 0;
  value = 0;
}
